import React, { useState } from 'react';
import { Form, Button, Alert, Card } from 'react-bootstrap';
import { put } from '../utils/api';
import './ChangePassword.css'; // Make sure this CSS file exists

const ChangePasswordForm = ({ onPasswordChangeSuccess, onCancel }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [alert, setAlert] = useState({ show: false, message: '', variant: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      setAlert({ show: true, message: 'New password and confirmation do not match.', variant: 'danger' });
      return;
    }

    setLoading(true);
    setAlert({ show: false, message: '', variant: '' });

    try {
      const response = await put('/auth/change-password', { currentPassword, newPassword });

      if (response.success) {
        setAlert({ show: true, message: response.message, variant: 'success' });
        setCurrentPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
        if (onPasswordChangeSuccess) {
          onPasswordChangeSuccess();
        }
      } else {
        setAlert({ show: true, message: response.message || 'Failed to change password.', variant: 'danger' });
      }
    } catch (error) {
      setAlert({ show: true, message: error.message || 'An error occurred.', variant: 'danger' });
    } finally {
      setLoading(false);
      setTimeout(() => setAlert({ show: false, message: '', variant: '' }), 5000);
    }
  };

  return (
    <Card className="change-password-card">
      <Card.Header>
        <h5 className="mb-0">Change Password</h5>
      </Card.Header>
      <Card.Body>
        {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formCurrentPassword">
            <Form.Label>Current Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formNewPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formConfirmNewPassword">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm new password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              required
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onCancel} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? 'Changing...' : 'Change Password'}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ChangePasswordForm;
